<script>
	import { navigate } from "svelte-routing";
	import CustomTable from "../../../../components/CustomTable/CustomTable.svelte";

	export let data = [];
	export let changeFetchParams;

	function navigateToDetails(id) {
		// navigate to the quotation form for given case ID
		navigate(`/issues/case-management/quotation/${id}`);
	}

	// handle parent sort event
	function handleSort({ detail: { column, direction } }) {
		changeFetchParams({ sortCol: column, sortDir: direction });
	}
</script>

<CustomTable
	columns={[
		{
			label: "Vehicle No",
			key: "plateNo",
			type: "link",
			linkBy: "vehicleId",
			linkTo: "/car-management/details/",
		},
		{
			label: "Case Closed On",
			key: "rejectedAt",
			type: "date",
			sortCol: 1,
		},
		{ key: "investigator", label: "Investigator" },
		{ key: "rejectedReason", label: "Reason" },
		{ label: "Case Origin", key: "caseOrigin", type: "masterdata" },
		{
			key: "actions",
			label: "Actions",
			type: "actions",
			event: navigateToDetails,
			action: "view",
		},
	]}
	rows={data}
	emptyMessage="There are currently no cases to display."
	on:sort={handleSort}
/>
